import { Head } from "@shared/components/head";
import { dynamicTranslations } from "@shared/utils/dynamicTranslation";
import { ActivityCard, ReadingsList } from "app/_modules/core/components/home";
import { IPathwayActivitiesResponse, IPathwayActivity } from "app/_modules/pathways/entities";
import { View } from "react-native";
import { ACTIVITY_STATUS } from "app/_modules/core/constants";
import { TActivityBucket } from "app/_modules/core/utils/activityCard";

type TBucketedActivity = { activity: IPathwayActivity, bucket: TActivityBucket };

export const HistoryActivitySection = ({ activities, isToday = false }: { activities: IPathwayActivitiesResponse, isToday?: boolean }) => {
    const { t } = dynamicTranslations();

    const completedActivities: TBucketedActivity[] = [];
    const standaloneActivities: TBucketedActivity[] = [];
    const incompleteActivities: TBucketedActivity[] = [];

    Object.entries(activities)
        .filter(([key, value]) => key !== "date" && Array.isArray(value) && value.length > 0)
        .forEach(([timeOfDay, activitiesList]) => {
            const bucket = timeOfDay as TActivityBucket;
            activitiesList.forEach((activity: IPathwayActivity) => {
                if (activity.status === ACTIVITY_STATUS.COMPLETED) {
                    if (activity.standalone) {
                        standaloneActivities.push({ activity, bucket });
                    } else {
                        completedActivities.push({ activity, bucket });
                    }
                } else if (!isToday || activity.status === ACTIVITY_STATUS.MISSED) {
                    incompleteActivities.push({ activity, bucket });
                }
            });
        });

    const renderCard = ({ activity, bucket }: TBucketedActivity) => (
        <ActivityCard key={activity.activityId} activity={activity} bucket={bucket} onPress={() => {}} disabled />
    );

    return (
        <View className="flex-col gap-4">
            {completedActivities.length > 0 && (
                <ReadingsList>{completedActivities.map(renderCard)}</ReadingsList>
            )}

            {standaloneActivities.length > 0 && (
                <>
                    <Head type="h3">{t('screens.activities.addedByYou')}</Head>
                    <ReadingsList>{standaloneActivities.map(renderCard)}</ReadingsList>
                </>
            )}

            {incompleteActivities.length > 0 && (
                <>
                    <Head type="h3">{t('screens.activities.whatYouForgot')}</Head>
                    <ReadingsList>{incompleteActivities.map(renderCard)}</ReadingsList>
                </>
            )}
        </View>
    );
};
